import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton";

export const Statement = ({ onAnswer }) => {
    const [isExiting, setIsExiting] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const emojis = ['🥑', '🥕', '🍎', '🫐', '🍕', '🥩', '🍗', '🍳', '🍣', '🥗', '🥪', '🌮', '🍜', '🍙', '🥝', '🍇', '🥭', '🍠'];
    const [activeEmojiIndices, setActiveEmojiIndices] = useState([0, 1]);
    
    // Generate shuffled emojis and their fixed positions once
    const [gridEmojis] = useState(() => {
        return [...emojis].sort(() => Math.random() - 0.5).map(emoji => ({
            emoji,
            offset: {
                x: Math.random() * 10 - 5,
                y: Math.random() * 10 - 5
            }
        }));
    });

    useEffect(() => {
        const interval = setInterval(() => {
            // Generate two random unique indices
            const newIndices = [];
            while (newIndices.length < 2) {
                const randomIndex = Math.floor(Math.random() * emojis.length);
                if (!newIndices.includes(randomIndex)) {
                    newIndices.push(randomIndex);
                }
            }
            setActiveEmojiIndices(newIndices);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        setTimeout(() => setShowButton(true), 1400);
    }, []);

    const handleContinue = () => {
        setShowButton(false);
        setTimeout(() => {
            setIsExiting(true);
            setTimeout(() => onAnswer('continue'), 800);
        }, 400);
    };

    return (
        <div 
            className={classNames(
                "relative h-full flex flex-col items-center justify-start px-6",
                isExiting 
                    ? "opacity-0" 
                    : "opacity-100",
                "transition-all duration-500 ease-in-out"
            )}
            style={{
                animation: "slideIn 500ms ease-out",
                background: "linear-gradient(80deg, rgba(240, 30, 111, 0.05) 12.92%, rgba(248, 94, 74, 0.05) 94.79%), #FFF"
            }}
        >
            <div className="text-center space-y-4 max-w-[600px] mt-4 mb-8">
                <div className="overflow-hidden">
                    <h2 className="text-[32px] md:text-[40px] leading-tight font-bold text-black">
                        In Atly, you can use over{' '} 
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                            50 filters
                        </span>{' '}to help you find the{' '}
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                            perfect
                        </span>{' '}
                        meal for your dietary needs
                    </h2>
                </div>
            </div>

            <div className="flex-1 flex items-center justify-center w-full mb-20">
                <div className="grid grid-cols-3 gap-6 w-full max-w-[400px] place-items-center">
                    {gridEmojis.map((item, i) => (
                        <div 
                            key={i}
                            className="text-3xl transition-opacity duration-300"
                            style={{
                                opacity: activeEmojiIndices.includes(i) ? 1 : 0.15,
                                transform: `translate(${item.offset.x}px, ${item.offset.y}px)`
                            }}
                        >
                            {item.emoji}
                        </div>
                    ))}
                </div>
            </div>

            <div 
                className={classNames(
                    "fixed bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#fff5f8] via-[#fff5f8] to-transparent",
                    "transition-all duration-500 pb-6 pt-10",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}
                style={{
                    background: "linear-gradient(to top, #fff5f8 50%, rgba(255, 245, 248, 0))"
                }}
            >
                <PorangeButton
                    full={true}
                    className="h-[56px] rounded-[16px] text-lg shadow-md"
                    onClick={handleContinue}
                >
                    Continue
                </PorangeButton>
            </div>
        </div>
    );
};

export default Statement;

const styles = `
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
`;

if (typeof document !== 'undefined') {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
}